import { GamesGridConfigurable } from 'react-easyrocket';
import { GameCard } from 'src/components/GameCard';
import { SkeletonOfAnySize } from 'src/components/Skeletons';

export const TOTAL_GAMES = 24;

export const GamesGrid = GamesGridConfigurable({
  renderGameCard: ({ key, ...props }) => <GameCard key={key} {...props} />,
  GameSkeletonComponent: () => (
    <SkeletonOfAnySize className="w-full aspect-[29/40] rounded-lg"></SkeletonOfAnySize>
  )
});
